// For now, only transforms keys. Adding value transformation will be a little trickier
import { snakeCase } from 'lodash';

export const deepTransform = (
  input: unknown,
  keyCallback: (input: string) => string,
  valueCallback = (i: unknown) => i,
) => {
  if (typeof input === 'string') return valueCallback(input);
  if (!input || typeof input !== 'object') return valueCallback(input);
  if (Array.isArray(input))
    return input.map((item): unknown =>
      deepTransform(item, keyCallback, valueCallback),
    );

  return Object.keys(input).reduce(
    (acc, key) => {
      const val = input[key as keyof typeof input];
      acc[keyCallback(key)] =
        typeof val === 'object'
          ? deepTransform(val, keyCallback, valueCallback)
          : valueCallback(val);
      return acc;
    },
    {} as { [key: string]: unknown },
  );
};

export const deepTransformNumericKeysToSnakeCase = (obj: object) =>
  deepTransform(obj, input => {
    return input.match(/[0-9]/g) ? snakeCase(input) : input;
  });

export const toSnakeCase = (str: string) => {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};
